/* eslint-disable */
import React, { useEffect, useState } from 'react';
import SubmitButtons from '../../dashboard/instructor/newCourse/SubmitButtons';
import UploadFile from '../../dashboard/instructor/newCourse/UploadFile';

const CreateOrUpdateLectureInputTemplate = ({
    register,
    errors,
    setValue,
    setDuration,
    lectureData,
    createLectureHandler,
    updateLectureHandler,
    setBgBlurModal,
}) => {
    const [isFileType, setFileType] = useState(null);
    const [preview, setPreview] = useState(null);
    const handleFileTypeChange = (e) => {
        const selectedFileType = e.target.value;
        setFileType(selectedFileType);
        setDuration(null);
    };
    const resetHandler = () => {
        setValue('lectureTitle', '');
        setValue('lectureDescription', '');
        setValue('fileType', '');
        setValue('lectureFile', '');
        setFileType(null);
        setPreview(null);
    };
    const cancelHandler = () => {
        setValue('lectureTitle', '');
        setValue('lectureDescription', '');
        setValue('fileType', '');
        setValue('lectureFile', '');
        setFileType(null);
        setPreview(null);
        setBgBlurModal(null);
    };
    useEffect(() => {
        if (!lectureData) {
            resetHandler();
        }
    }, [lectureData]);

    return (
        <div className='lg:w-[50rem] md:w-[40rem] w-full py-2 sm-45:px-6 bg-richblack-700 rounded-md h-fit m-auto'>
            <div className='w-full mx-auto flex flex-col gap-4'>
                <div>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Lecture Title <sup className='text-pink-200'>*</sup></p>
                        <input
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            type='text'
                            id='lectureTitle'
                            name='lectureTitle'
                            placeholder='Enter Lecture Title'
                            {...register("lectureTitle")}
                        />
                    </label>
                </div>
                <div>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>Lecture Description</p>
                        <textarea
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] h-24 text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            placeholder='Enter Lecture Description'
                            name='lectureDescription'
                            id='lectureDescription'
                            {...register('lectureDescription')}
                        />
                    </label>
                </div>
                <div>
                    <label className='w-full'>
                        <p className='text-[0.875rem] leading-[1.375rem] text-richblack-5 mb-1'>File Type <sup className='text-pink-200'>*</sup></p>
                        <select
                            className='w-full p-[12px] bg-richblack-800 rounded-[0.5rem] text-richblack-5 outline-none'
                            style={{ boxShadow: 'rgba(255, 255, 255, 0.18) 0px -1px 0px inset' }}
                            id='fileType'
                            defaultValue=''
                            {...register('fileType', { onChange: handleFileTypeChange })}
                        >
                            <option value='' disabled>Select Kind of Lecture</option>
                            <option value='video/'>Video</option>
                            <option value='application/pdf' disabled>PDF File</option>
                            <option value='text/plain' disabled>Text File</option>
                        </select>
                    </label>
                </div>
                {isFileType && (
                    <UploadFile
                        label={isFileType === 'video/' ? "Lecture Video File" : isFileType === 'application/pdf' ? 'Lecture PDF File' : 'Lecture Text File'}
                        name="lectureFile"
                        placeholder={isFileType === 'video/' ? "video" : isFileType === 'application/pdf' ? 'PDF' : 'Text File'}
                        accept={isFileType === 'video/' ? "video/*" : isFileType === 'application/pdf' ? '.pdf, .pages' : '.pages, .text'}
                        startsWith={isFileType}
                        register={register}
                        errors={errors}
                        setValue={setValue}
                        preview={preview}
                        setPreview={setPreview}
                        setDuration={setDuration}
                    />
                )}
                <div>
                    <SubmitButtons
                        submitText={lectureData ? 'Save' : 'Create'}
                        resetText='Reset'
                        cancelText='Cancel'
                        submitType='button'
                        resetType='reset'
                        submitHandler={lectureData ? updateLectureHandler : createLectureHandler}
                        resetHandler={resetHandler}
                        cancelHandler={cancelHandler}
                    />
                </div>
            </div>
        </div>
    );
};

export default CreateOrUpdateLectureInputTemplate;